import React from 'react';
import { IconContainer } from './IconContainer';

const FiltersIcon = (props) => {
    return (
        <IconContainer ariaLabel="filters" {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M7 3V6H3V8H7V11H9V3H7ZM11 8H21V6H11V8ZM17 13V16H21V18H17V21H15V13H17ZM13 18H3V16H13V18Z"/>
            </svg>
        </IconContainer>
    )
}

export { FiltersIcon };